import MultiEditSelect from './MultiEditSelect';

export default MultiEditSelect;
